import {
  getCasLogoutUrl,
  getEntraLogoutUrl,
  SSO_LOCAL_LOGIN_PATH,
  SSO_PARTNERS,
  SSO_PROTOCOLS,
} from "./ssoConfig";

function getLocalLoginDestination(contextRoot) {
  return contextRoot + SSO_LOCAL_LOGIN_PATH;
}

export function getSsoLogoutDestination({
  descriptor,
  isLoginViaNu,
  isLoginViaEmu,
  host = window.location.host,
  origin = window.location.origin,
  contextRoot = process.env.REACT_APP_CONTEXT_ROOT || "",
}) {
  const protocol = String(descriptor?.protocol || "").trim().toUpperCase();
  const localLoginDestination = getLocalLoginDestination(contextRoot);

  if (protocol === SSO_PROTOCOLS.OIDC) {
    return getEntraLogoutUrl(origin);
  }

  if (descriptor) {
    if (protocol !== SSO_PROTOCOLS.CAS) return localLoginDestination;
    return getCasLogoutUrl(descriptor.partner, host) || localLoginDestination;
  }

  const hasLegacyNuHint = isLoginViaNu === true;
  const hasLegacyEmuHint = isLoginViaEmu === true;
  if (hasLegacyNuHint === hasLegacyEmuHint) return localLoginDestination;

  const legacyPartner = hasLegacyNuHint
    ? SSO_PARTNERS.NU
    : SSO_PARTNERS.EMU;
  return getCasLogoutUrl(legacyPartner, host) || localLoginDestination;
}
